module.exports = "/images/3.png?4e98bf3b65f3bb0d5b3ad75f6f4128b7";